import * as _ from 'es-toolkit';

/** Normalize a ticket window payload before API / impact wizard execute. */
export function prepareWindowForApi(window) {
    const prepared = _.cloneDeep(window);

    ['screening_id', 'duration', 'start_at', 'stop_at', 'nsame_screening', 'overlap'].forEach(property => {
        const value = prepared[property];
        if (_.isNull(value) || value === '') {
            delete prepared[property];
        }
    });

    if (!prepared.screening_id && !prepared.duration && !prepared.start_at && !prepared.stop_at) {
        prepared.duration = 'P1Y';
    }

    ['nbookings', 'nsame_screening'].forEach(property => {
        prepared[property] = parseInt(prepared[property], 10);
    });
    if (!_.isNumber(prepared.nbookings) || Number.isNaN(prepared.nbookings)) {
        prepared.nbookings = 0;
    }
    if (!_.isNumber(prepared.nsame_screening) || Number.isNaN(prepared.nsame_screening)) {
        prepared.nsame_screening = 1;
    }

    return prepared;
}

export function prepareWindowsForApi(windows) {
    return (windows || []).map(prepareWindowForApi);
}
